import React from "react";
import { Button, Tree, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useGoodsModel } from "../materialModel";
import { DataTable } from "./DataTable";
import { useNavModel } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { importPropsConfig } from "@/utils/importFile";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
export const DataBox = () => {
    const { selectedRowKeys, updateEditFormVal, loadData, importGoods, exportGoods, downloadTpl, importImgGoods } = useGoodsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let goodsEditKey = "13-2-2";
        let isFindNav = findNav(goodsEditKey);
        if (!isFindNav) {
            addNav(goodsEditKey, { id: selectedRowKeys[0], mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "物料跳转详情",
                title:Locale["Jump to the detail page"],
                type: "warning",
                // text: "您还有物料详情未保存，是否跳转",
                text:Locale["The detail page has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(goodsEditKey, { id: selectedRowKeys[0], mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const action = <>

        <AuthButton
            // resCode="MaterialManagementAdd"
            resCode={ResourcesAuthBtn[mianCode]["MaterialManagementAdd"]}
            onClick={() => addNav("13-2-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="MaterialManagementEdit"
            resCode={ResourcesAuthBtn[mianCode]["MaterialManagementEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="MaterialManagementImport"
            resCode={ResourcesAuthBtn[mianCode]["MaterialManagementImport"]}
        >
            <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/material/import`, loadData)}>
                <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
            </Upload>
        </AuthButton>
        <AuthButton
            // resCode="MaterialManagementDownloadTheTemplate"
            resCode={ResourcesAuthBtn[mianCode]["MaterialManagementDownloadTheTemplate"]}
            onClick={() => { downloadTpl("id").then() }}
            // name="下载模板"
            name={Locale["Download template"]}
        />

        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { addNav("13-2-1", { id: "", mode: "add" }) }}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/material/import`, loadData)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl("id").then() }}
        >下载模板</Button> */}
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}

